import Vue from 'vue'
import Router from 'vue-router'
import { NODE_ENV } from '@com/config/env'

import butlerRouter from './butler'
import creative from './creative'
import repository from './repository'
import system from './system'
import report from './report'
import demoRoute from './demo'
import collection from './collection'
import producer from './producer'
import mindworks from './mindworks'
import dashboard from './dashboard'
import warrant from './warrant'
import endcard2gif from '../../../endcard2gif/index'

const _import = require('./_import_' + NODE_ENV)
// in development-env not use lazy-loading, because lazy-loading too many pages will cause webpack hot update too slow. so only in production use lazy-loading;
// detail: https://panjiachen.github.io/vue-element-admin-site/#/lazy-loading

Vue.use(Router)

/**
* hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
* alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
*                                if not set alwaysShow, only more than one route under the children
*                                it will becomes nested mode, otherwise not show the root menu
* redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
* name:'router-name'             the name is used by <keep-alive> (must set!!!)
* meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
**/

export const routerMap = [
  // 授权页面
  {
    path: '/auth',
    component: _import('auth/index'),
    hidden: true,
  },
  // 视频自动化处理工具，不需要加权限限制，任何人都可用
  {
    path: '/mindwork-view',
    component: _import('mindworkView/index'),
    hidden: true,
  },
  {
    path: '/video-processor',
    component: _import('automation/index'),
    hidden: true,
  },
  {
    path: '/tools',
    hidden: true,
    component: {
      template: '<div><router-view></router-view></div>',
    },
    children: [
      {
        path: 'mw-viewer',
        name: 'tools.mw-viewer',
        component: () => import('@/views/tools/mw-viewer/index'),
        meta: {
          title: 'mindworks预览地址生成器',
        },
      },
    ],
  },
  {
    path: '/404',
    component: _import('404'),
    hidden: true,
  },
  // endcard转gif
  {
    path: '/endcard2gif',
    component: endcard2gif,
    hidden: true,
  },
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: routerMap,
})

export const asyncRouterMap = [
  {
    path: '/',
    redirect: '/system/profile',
  },
  // new router
  dashboard,
  butlerRouter,
  producer,
  warrant,
  repository, // 素材存储库
  demoRoute,
  collection, // 采集管理
  report, // 数据报表
  creative, // 创意方向
  mindworks, // 官网管理
  system, // 系统管理

  { path: '*', redirect: '/404', hidden: true },
]
